import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de masse de fer - Calcul de la masse de fer";
const DESCRIPTION =
  "Calculatrice de masse de fer - Calcul de la masse de fer. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "iron mass, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/iron-mass/";
function Calculator() {
    const [density, setDensity] = useState(7.8);
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [volume, setVolume] = useState('');
    const [ironMass, setIronMass] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('Veuillez entrer les dimensions correctement');
            setVolume('');
            setIronMass('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue) || lengthValue <= 0 || widthValue <= 0 || heightValue <= 0) {
            setError('Veuillez entrer des valeurs valides et positives pour les dimensions');
            setVolume('');
            setIronMass('');
            return;
        }
        const ironVolume = lengthValue * widthValue * heightValue;
        setVolume(ironVolume.toFixed(2));
        const mass = ironVolume * density;
        setIronMass(mass.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>Comment calculer la masse de fer</h2>
                                <p>
                                    La calculatrice de masse de fer utilise une formule pour calculer le poids du fer, qui est basée sur l'équation suivante :
                                </p>
                                <p>
                                    Poids = Densité × Volume
                                </p>
                                <p>
                                    Dans cette formule, le poids est la quantité requise de fer (en grammes), et la densité standard du fer est 7,8 g/cm³.
                                </p>
                                <p>
                                    Pour effectuer le calcul, vous devez entrer les dimensions d'une pièce de fer (longueur, largeur et hauteur) pour déterminer le volume. Ensuite, la calculatrice calculera le poids en fonction de la densité et du volume.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div dir="ltr">
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Longueur (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Longueur"
                                                value={length}
                                                onChange={(e) => setLength(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Largeur (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Largeur"
                                                value={width}
                                                onChange={(e) => setWidth(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Hauteur (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Hauteur"
                                                value={height}
                                                onChange={(e) => setHeight(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            Calculer
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>Erreur : {error}</p>
                                        ) : (
                                            <>
                                                {volume !== '' && (
                                                    <>
                                                        <p className='p-3 mb-2 bg-success text-white'>
                                                            Volume : {volume} cm³
                                                        </p>
                                                        <p className='p-3 mb-2 bg-info text-black'>
                                                            Masse de fer : {ironMass} grammes
                                                        </p>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <br />
        </div>
    );
}
export default Calculator;
